const t = {
  name: "SkipLeft",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4138 12.0002L17.4138 8.00015L15.9996 6.58594L10.5854 12.0002L15.9996 17.4144L17.4138 16.0002L13.4138 12.0002Z" fill="currentColor"/>
<path d="M7 7.00012L7 17.0001H9V7.00012L7 7.00012Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SkipLeft
};
